import { FC } from "react";
import { PlayerBatStats } from "../../schema/schema";
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import sortBy from "lodash.sortby";

interface StatsTableProps {
	stats: PlayerBatStats[];
}

type RowData = {
	Name: string;
	Matches: number;
	Innings: number;
	Runs: number;
	Balls: number;
	HS: number;
	"HS NO": string;
	Average: number | "-";
	Fours: number;
	Sixes: number;
	"50s": number;
	"100s": number;
	"Not Outs": number;
	Ducks: number;
};

const BatStatsTable: FC<StatsTableProps> = ({ stats }) => {
	const sortedStats = sortBy(stats, "Name").filter(stat => !stat.Name.includes("***"));

	const rows: RowData[] = sortedStats.map(({ Name, Statistics }, idx) => {
		let avg: number | "-" =
			Math.round(
				(Statistics.BattingAggregate / (Statistics.BattingInnings - Statistics.BattingNotOuts)) *
					100
			) / 100;

		if (Statistics.BattingInnings === Statistics.BattingNotOuts) {
			avg = "-";
		}

		if (Statistics.BattingAggregate === 0) {
			avg = 0;
		}

		return {
			Name: Name,
			Matches: Statistics.Matches,
			Innings: Statistics.BattingInnings,
			Runs: Statistics.BattingAggregate,
			Balls: Statistics.BattingBallsFaced,
			HS: Statistics.BattingHighScore,
			"HS NO": Statistics.BattingNotOuts ? "*" : "",
			Average: avg,
			Fours: Statistics.BattingFours,
			Sixes: Statistics.BattingSixes,
			"50s": Statistics.Batting50s,
			"100s": Statistics.Batting100s,
			"Not Outs": Statistics.BattingNotOuts,
			Ducks: Statistics.Batting0s
		};
	});

	const columns = [
		{ field: "Name" as keyof RowData, filter: true, maxWidth: 200 },
		{ field: "Matches" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Innings" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Runs" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Balls" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "HS" as keyof RowData, filter: true, maxWidth: 80 },
		{ field: "HS NO" as keyof RowData, maxWidth: 80 },
		{ field: "Average" as keyof RowData, filter: true, maxWidth: 120 },
		{ field: "Fours" as keyof RowData, maxWidth: 100 },
		{ field: "Sixes" as keyof RowData, maxWidth: 100 },
		{ field: "50s" as keyof RowData, maxWidth: 80 },
		{ field: "100s" as keyof RowData, maxWidth: 80 },
		{ field: "Not Outs" as keyof RowData, maxWidth: 100 },
		{ field: "Ducks" as keyof RowData, maxWidth: 100 }
	];

	return (
		<div className="w-full overflow-x-auto">
			<div className="ag-theme-quartz min-w-[980px]" style={{ height: 720 }}>
				<AgGridReact columnMenu="new" rowData={rows} columnDefs={columns} />
			</div>
		</div>
	);
};

export default BatStatsTable;
